// extracted by mini-css-extract-plugin
export default {"title":"mSZl9","mobile":"_2Nskt"};